import {
  SlBreadcrumb
} from "./chunk.QNHPSS6Z.js";
import {
  breadcrumb_styles_default
} from "./chunk.IIARPASN.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/breadcrumb/breadcrumb.ts
import { t } from "i18next";
var FadvBreadcrumb = class extends SlBreadcrumb {
  makeSeparator() {
    const separator = document.createElement("span");
    separator.textContent = "/";
    separator.slot = "separator";
    return separator;
  }
  handleBackClick() {
    emit(this, "breadcrumb-back", { detail: { currentPage: "currentPage" } });
  }
  handleSlotChange() {
    const items = [...this.defaultSlot.assignedElements({ flatten: true })].filter((item) => hasTag(item, "fadv-breadcrumb-item"));
    items.forEach((item, index) => {
      const separator = item.querySelector('[slot="separator"]');
      if (separator === null) {
        item.append(this.makeSeparator());
      } else if (separator.hasAttribute("data-default")) {
        separator.replaceWith(this.makeSeparator());
      } else {
      }
      if (index === items.length - 1) {
        item.setAttribute("aria-current", "page");
      } else {
        item.removeAttribute("aria-current");
      }
    });
  }
  render() {
    return $`<nav part="base" class="breadcrumb" aria-label=${this.label}><sl-icon-button label=${t("components:breadcrumb.backButton")} class="breadcrumb__icon-button" @click=${this.handleBackClick} library="solid" name="chevron-left" ></sl-icon-button><slot @slotchange=${this.handleSlotChange}></slot></nav>`;
  }
};
FadvBreadcrumb.styles = breadcrumb_styles_default;
FadvBreadcrumb = __decorateClass([
  n("fadv-breadcrumb")
], FadvBreadcrumb);

export {
  FadvBreadcrumb
};
